/*
 * Names for new drafts.
 *
 * Deliberately not one of the generic name libraries: those draw from
 * adjective/animal dictionaries and produce "Focused Ruthless Wolf", which
 * reads like a generated app name rather than something an FPL manager
 * would call a team. These banks are all fantasy-football vocabulary, so
 * every combination sounds like it came from the game.
 *
 * Two patterns rather than one, because a single template becomes obvious
 * after a handful of rerolls.
 */

const OPENERS = [
	'Rampant', 'Reckless', 'Feral', 'Silky', 'Rogue', 'Doomed', 'Blessed',
	'Cursed', 'Ruthless', 'Nuclear', 'Eternal', 'Marauding', 'Fearless',
	'Unhinged', 'Tactical', 'Patient', 'Greedy', 'Humble', 'Vengeful',
	'Prophetic', 'Deluded', 'Serene', 'Panicked', 'Smug', 'Bold',
];

const SUBJECTS = [
	'Wildcard', 'Bench Boost', 'Triple Captain', 'Free Hit', 'Differential',
	'Bandwagon', 'Punt', 'Haul', 'Blank', 'Nutmeg', 'Rabona', 'Panenka',
	'Rebuild', 'Gamble', 'Hedge', 'Template', 'Maverick', 'Rotation',
	'Cornerstone', 'Enabler', 'Sleeper', 'Bargain', 'Premium', 'Captaincy',
];

const CLUBS = [
	'XI', 'United', 'Wanderers', 'Rovers', 'Athletic', 'Albion', 'Town',
	'County', 'Academy', 'Select', 'Invincibles', 'Merchants', 'Enjoyers',
	'Hipsters', 'Dealers', 'Believers',
];

const pick = (list) => list[Math.floor(Math.random() * list.length)];

export function randomDraftName() {
	return Math.random() < 0.5
		? `${pick(OPENERS)} ${pick(SUBJECTS)}`
		: `${pick(SUBJECTS)} ${pick(CLUBS)}`;
}
